import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

import { useSession } from "@/hooks/use-session";

export const LogoutModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setSession } = useSession();

  const handleLogout = () => {
    setSession(null);
    navigate(0);
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button className="text-white" size="sm" variant="ghost">
          {t("labels.logout")}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("logout.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("logout.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("labels.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={handleLogout}>
            {t("labels.continue")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
